module.exports = __webpack_public_path__ + "img/gongan.58fa8cca.png";